import CardDetails from '../../components/CardDetails';
import isServiceProfileAdded from '../../add/isServiceProfileAdded';
import { OPERATOR_PLATFORM, VENDOR_DEFINED } from '../../constants';

/** The name Add New Service shows for a service profile. */
export const getServiceProfileName = (profile) => {
    if (profile?.serviceType === VENDOR_DEFINED) {
        return profile.serviceDefinition?.name;
    }
    if (profile?.serviceType === OPERATOR_PLATFORM) {
        return profile.customDisplayName;
    }
    return CardDetails(
        profile?.serviceType,
        profile?.serviceDefinition?.platformID,
    )?.serviceName;
};

/**
 * (3134) The services behind "Show more services": profiles offered on Add
 * New Service that the company hasn't added yet, by name.
 *
 * @param {object[]} profiles - /ServiceProfiles/Available entries
 * @param {object[]} existingServices - the dashboard payload's services
 * @returns {{ profile: object, name: string, icon: string }[]}
 */
export default function getAvailableServices(profiles, existingServices) {
    return (Array.isArray(profiles) ? profiles : [])
        .filter((profile) => !isServiceProfileAdded(profile, existingServices))
        .map((profile) => ({
            profile,
            name: getServiceProfileName(profile) || '',
            icon: CardDetails(
                profile.serviceType,
                profile.serviceDefinition?.platformID,
            )?.icon,
        }))
        .filter((service) => service.name)
        .sort((a, b) => a.name.localeCompare(b.name));
}
